import { useLocalSearchParams } from 'expo-router';
import { useMemo } from 'react';
import { WorkoutForm } from '~/workout/components/workout-form/WorkoutForm';
import { useCurrentOverviewDate } from '~/calendar/hooks/useCurrentOverviewDate';

export default function WorkoutCreatePage() {
  const { initialDate } = useLocalSearchParams<{ initialDate?: string }>();
  const currentOverviewDate = useCurrentOverviewDate();

  // Use URL parameter if provided, otherwise fall back to current overview date
  const selectedDate = useMemo(
    () => (initialDate ? new Date(initialDate) : currentOverviewDate),
    [initialDate, currentOverviewDate],
  );

  return <WorkoutForm initialDate={selectedDate} />;
}
